// components
import {SettingsValueProps} from './settings/type'

// LAYOUT
// ----------------------------------------------------------------------

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32
}

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'rtl',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'purple',
  themeStretch: false
}
const config = {
  apiUrl: process.env.REACT_APP_API || '',
  kohApiUrl: process.env.REACT_APP_KOH_API || '',
  isProduction: process.env.REACT_APP_BRANCH_NAME === 'main',
  isMain: process.env.REACT_APP_BRANCH_NAME === 'main',
  isDevelopment: process.env.NODE_ENV === 'development',
  logRocketAppId: process.env.REACT_APP_LOGROCKET_APPID || '',
  rollbarPostClientItem: process.env.REACT_APP_ROLLBAR_POST_CLIENT_ITEM || '',
  apiCityUrl: process.env.REACT_APP_API_CITY_URL || '',
  stagingUrl: process.env.REACT_APP_API_STAGINTG || ''
}

export default config
